import { fetchUtils, } from 'react-admin';
function modifyOptions(options?: fetchUtils.Options): fetchUtils.Options {
  if (!options) {
    options = {};
  }
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }

  // add your own headers here
  if (null !== localStorage.getItem('token')) {
    (options.headers as Headers).set('X-Authorization', 'Bearer ' + localStorage.getItem('token'));
  }
  if (null !== localStorage.getItem('auth')) {
    (options.headers as Headers).set('X-API-Key', JSON.parse(localStorage.getItem('auth') as string).api_key);
  }
  if (null !== localStorage.getItem('impersonate')) {
    (options.headers as Headers).set('X-impersonate', localStorage.getItem('impersonate') as string);
  }
  return options;
}
async function fetchJson(url: string, options?: fetchUtils.Options) {
  options = modifyOptions(options);
  const x = await fetchUtils.fetchJson(url, options);
  // @TODO check other headers
  return x;
}
export async function fetchRaw(url: string, options?: fetchUtils.Options) {
  options = modifyOptions(options);
  // @TODO check other headers
  return fetch(url, options);
}
export async function fetchDownload(url: string, options?: fetchUtils.Options, filename?: string) {
  options = modifyOptions(options);
  // @TODO check other headers
  return fetch(url, options)
    .then(response => response.blob().then(blob => ({ response, blob })))
    .then(({ response, blob }) => {
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      let filename = null;
      console.log(response.headers);
      if (response.headers.has('x-filename')) {
        filename = response.headers.get('x-filename');
      }
      if (null === filename && response.headers.has('Content-Disposition') && null !== response.headers.get('Content-Disposition')) {
        let matches = (response.headers.get('Content-Disposition') as string).match(/filename="(.*)"/i);
        if (null !==matches) {
          filename = matches[1];
        }
      }
      if (null === filename) {
        filename = 'temp.tmp';
      }
      a.download = filename;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again
    });;
}
export default fetchJson;
